import update from 'immutability-helper'
import {
  GET_EVENT_LISTS,
  GET_SUBEVENT_LISTS,
  GET_EVENT_CATEGORIES,
  GET_FILTER_EVENT,
  GET_EVENT_PROMOTED,
  GET_EVENT_DETAIL,
  GET_OTHER_EVENTS,
  LOAD_MORE_EVENTS,
  LIKE_EVENT,
} from './constants'

export const getEventLists = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_EVENT_LISTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_EVENT_LISTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
        pagination: action.result.pagination,
      }
    case GET_EVENT_LISTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    case LOAD_MORE_EVENTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case LOAD_MORE_EVENTS.success:
      return {
        ...state,
        isRequesting: false,
        data: update(state.data, {
          $push: action.result.result,
        }),
        pagination: action.result.pagination,
      }
    case LOAD_MORE_EVENTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getSubeventLists = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_SUBEVENT_LISTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_SUBEVENT_LISTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
        pagination: action.result.pagination,
      }
    case GET_SUBEVENT_LISTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getEventPromoted = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_EVENT_PROMOTED.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_EVENT_PROMOTED.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case GET_EVENT_PROMOTED.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getEventDetail = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_EVENT_DETAIL.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_EVENT_DETAIL.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case GET_EVENT_DETAIL.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getEventFilter = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_FILTER_EVENT.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_FILTER_EVENT.success:
      return {
        ...state,
        isRequesting: false,
        filter: action.result.result,
      }
    case GET_FILTER_EVENT.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getEventCategories = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_EVENT_CATEGORIES.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_EVENT_CATEGORIES.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case GET_EVENT_CATEGORIES.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const getOtherEvents = (state = {
  isRequesting: false,
}, action) => {
  switch (action.type) {
    case GET_OTHER_EVENTS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_OTHER_EVENTS.success:
      return {
        ...state,
        isRequesting: false,
        data: action.result.result,
      }
    case GET_OTHER_EVENTS.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

export const likedEvents = (state = {
  isRequesting: false,
  likedEvents: [],
}, action) => {
  switch (action.type) {
    case LIKE_EVENT.request:
      return {
        ...state,
        isRequesting: true,
      }
    case LIKE_EVENT.success: {
      const { result, event } = action
      const prevLikedEvents = state.likedEvents
      const newLikedEvents = !result.data ? prevLikedEvents : [...prevLikedEvents, event]

      return {
        ...state,
        isRequesting: false,
        likedEvents: newLikedEvents,
      }
    }
    case LIKE_EVENT.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/Event/reducers.js